export default "https://cdn-web.disco.co/default-user-cover-photo-bc5e7942fd0541686783664d64542f8d.png";